<svg><use [attr.xlink:href]="path"></use></svg>


// WEBPACK FOOTER //
// /mnt/e/apps/architect3/client/node_modules/vebto-client/core/ui/svg-icon/svg-icon.component.html